// ABOUTME: Global initialization event tracker for debugging storage provider initialization
// ABOUTME: Tracks all initialization events with timestamps for the debug overlay

export interface InitEvent {
    timestamp: number;
    type: 'info' | 'success' | 'warning' | 'error' | 'persistence' | 'sql';
    component: string;
    message: string;
    details?: any;
}

class InitializationTracker {
    private events: InitEvent[] = [];
    private listeners: ((events: InitEvent[]) => void)[] = [];

    addEvent(type: InitEvent['type'], component: string, message: string, details?: any) {
        const event: InitEvent = {
            timestamp: Date.now(),
            type,
            component,
            message,
            details
        };
        
        this.events.push(event);
        console.log(`[${component}] ${message}`, details || '');
        
        // Notify listeners
        this.listeners.forEach(listener => listener(this.events));
    }

    getEvents(): InitEvent[] {
        return [...this.events];
    }

    subscribe(listener: (events: InitEvent[]) => void): () => void {
        this.listeners.push(listener);
        // Return unsubscribe function
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    clear() {
        this.events = [];
        this.listeners.forEach(listener => listener(this.events));
    }
}

export const initTracker = new InitializationTracker();